<script setup lang="ts">
import InputField from '@/components/Fields/InputField.vue'
import { EDebounceTime } from '@/utils/debounceUtils'
import { useDebounceFn } from '@vueuse/core'
import { ref } from 'vue'

type Props = {
    epc?: string
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: string): void
}
const emit = defineEmits<Emits>()

const handleTyping = (value: string) => {
    isLoadingName.value = true
    debouncedName(value)
}
const isLoadingName = ref(false)
const debouncedName = useDebounceFn((epc: string) => emit('change', epc), EDebounceTime.DEFAULT)
</script>

<template>
    <InputField label="EPC" :modelValue="epc" @change="handleTyping($event)" />
</template>
